import { rowColumn, tableOptions } from "../../../components/table/Table";
import { assignStatusPrimaryOptions, assignStatusSecondaryOptions } from "../../formObjects/application/assignStatusForm";
import { getFilterOptions } from "../../CommonFunctions";

export const kindergartenCheckerListTable = (currPath: string, tableType: "fundedKinderName" | "kindergartenNameOther"): rowColumn[] => [
  {
    label: "KIS ID",
    column: "id",
    type: "string",
    allowSort: true,
    sortOn: "Id",
    frozen: true,
  },
  {
    label: "Kindergarten",
    column: "kindergartenNameOther",
    type: "string",
    isVisible: tableType === "kindergartenNameOther",
    allowSort: true,
    sortOn: "KindergartenNameOther",
  },
  {
    label: "Group",
    column: "groupInformationWeeklyData",
    type: "string",
    body: (rowData) => {
      return (
        <p className="m-0">
          {
            // Display distinct group names from both groupNames and otherGroupNames columns, split at ',' and separated by ';'
            // Ref to US 52397 for more info
            rowData.groupInformationWeeklyData != null && rowData.groupInformationWeeklyData.length > 0
              ? [
                  ...new Set(
                    rowData.groupInformationWeeklyData.flatMap((group: any) =>
                      `${group.groupNames ?? ""},${group.otherGroupNames ?? ""}`
                        .split(",")
                        .map((value: string) => value.trim())
                        .filter(Boolean)
                    )
                  ),
                ].join(" ; ")
              : ""
          }
        </p>
      );
    },
    sortOn: "GroupInformationWeeklyData",
  },
  {
    label: "First Name",
    column: "firstName",
    type: "string",
    sortOn: "FirstName",
    isFilter: true,
    filterType: "search",
  },
  {
    label: "Last Name",
    column: "lastName",
    type: "string",
    sortOn: "LastName",
    isFilter: true,
    filterType: "search",
  },
  {
    label: "Application Type",
    column: "typeOfApplication",
    type: "string",
    sortOn: "TypeOfApplication",
    body: (rowData) => {
      return <p className="m-0">{rowData.typeOfApplication === null ? "New" : rowData.typeOfApplication === 0 ? "Appeal" : "Transfer"}</p>;
    },
  },
  {
    label: "Appeal #",
    column: "applicationNumber",
    type: "string",
    sortOn: "ApplicationNumber",
    body: (rowData) => {
      return <p className="m-0">{rowData.typeOfApplication === 0 ? rowData.applicationNumber : ""}</p>;
    },
  },
  {
    label: "Status",
    column: "statusComputed",
    type: "string",
    sortOn: "StatusComputed",
    isFilter: true,
    filterType: "multiselect",
    filterElements: getFilterOptions(assignStatusPrimaryOptions, assignStatusSecondaryOptions, [
      { secondaryOption: "Presubmission" },
      { secondaryOption: "Withdrawn" },
      { secondaryOption: "Unable to process" },
      { secondaryOption: "Add Info not received" },
    ]),
  },
  {
    label: "Assessment Complete",
    column: "assessmentComplete",
    type: "date",
    sortOn: "AssessmentComplete",
  },
  {
    label: "Eligible",
    column: "isApplicationEligible",
    type: "string",
    sortOn: "IsApplicationEligible",
    isFilter: true,
    filterType: "multiselect",
    filterElements: [
      { label: "Yes", value: "Yes" },
      { label: "No", value: "No" },
    ],
    body: (rowData) => {
      return <p className="m-0">{rowData.isApplicationEligible}</p>;
    },
  },
  {
    label: "LGA",
    column: "lga",
    type: "string",
    sortOn: "LGA",
  },
  {
    label: "AA Child",
    type: "string",
    body: (rowData) => {
      return (
        <p className="m-0">
          {rowData.additionalAssistant == null
            ? null
            : rowData.additionalAssistantSupportApproved === 1 && rowData.additionalAssistant === true
              ? rowData.hoursAllocatedToChild
              : "No"}
        </p>
      );
    },
  },
  {
    label: "AA Group",
    type: "string",
    body: (rowData) => {
      return (
        <p className="m-0">
          {rowData.additionalAssistant == null
            ? null
            : rowData.additionalAssistantSupportApproved === 1 && rowData.additionalAssistant === true
              ? rowData.hoursAllocatedForGroupComplexity
              : "No"}
        </p>
      );
    },
  },
  {
    label: "AA Total",
    type: "string",
    body: (rowData) => {
      return (
        <p className="m-0">
          {rowData.additionalAssistant == null
            ? null
            : rowData.additionalAssistantSupportApproved === 1 && rowData.additionalAssistant === true
              ? rowData.totalHoursAllocated
              : "No"}
        </p>
      );
    },
  },
  {
    label: "Consultancy",
    type: "string",
    body: (rowData) => {
      return (
        <p className="m-0">
          {rowData.specialistConsultancy == null
            ? null
            : rowData.specialistConsultancy === true &&
                (rowData.specialistConsultancyRequestedOrRecommended === 2 ||
                  (rowData.specialistConsultancyRequestedOrRecommended === 1 && rowData.specialistConsultancySupportApproved === 1))
              ? "Yes"
              : "No"}
        </p>
      );
    },
  },
  {
    label: "Training",
    type: "string",
    body: (rowData) => {
      return (
        <p className="m-0">
          {rowData.specialistTraining == null
            ? null
            : rowData.specialistTraining === true && rowData.specialistTrainingSupportApproved === 1
              ? "Yes"
              : "No"}
        </p>
      );
    },
  },
  {
    label: "Mods",
    type: "string",
    body: (rowData) => {
      return (
        <p className="m-0">
          {rowData.minorBuildingModifications == null
            ? null
            : rowData.minorBuildingModifications === true && rowData.minorWorksSupportApproved === 1
              ? "Yes"
              : "No"}
        </p>
      );
    },
  },
  {
    label: "Actions",
    body: (rowData) => <a href={`${currPath}/${rowData.discriminator}/${rowData.id}`}>View Details</a>,
  },
];

export const kindergartenCheckerOptions: tableOptions = {
  sortField: undefined,
  sortOrder: undefined,
  sortColumn: "Id",
  sortDirection: "desc",
};
